module.exports = __webpack_public_path__ + "static/media/hr-1541478160164-2048x2048.8a855839.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/community-gardens/hr-1541478160164-2048x2048.png
// module id = 722
// module chunks = 11